<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title"><strong>{{$t('medium_grant.diligence__9_checklist')}}</strong></h4>
        <p class="mt-3 white-space-pre">{{$t('medium_grant.diligence__9_checklist_sub')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-9">
        <table width="100%">
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.checklist1c">
                {{$t('medium_grant.diligence__9_checklist1c')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist1c_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionArticlesOfIncorporation" :file-data="GrantForm.files.diligence.revisionArticlesOfIncorporation" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isRevisionEditable" section="diligence.revisionArticlesOfIncorporation"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.checklist1c2">
                {{$t('medium_grant.diligence__9_checklist1c2')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist1c2_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionOrgInCountry" :file-data="GrantForm.files.diligence.revisionOrgInCountry" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionOrgInCountry"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.checklist3">
                {{$t('medium_grant.diligence__9_checklist3')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist3_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionCertificationOfTax" :file-data="GrantForm.files.diligence.revisionCertificationOfTax" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isRevisionEditable" section="diligence.revisionCertificationOfTax"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.checklist4a">
                {{$t('medium_grant.diligence__9_checklist4a')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist4a_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionAuditReport" :file-data="GrantForm.files.diligence.revisionAuditReport" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionAuditReport"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.checklist4b">
                {{$t('medium_grant.diligence__9_checklist4b')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist4b_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionAccountingProcurement" :file-data="GrantForm.files.diligence.revisionAccountingProcurement" :size-limit="GrantForm.fileSizeLimit" :is-editable="GrantForm.isRevisionEditable" section="diligence.revisionAccountingProcurement"></upload-file>
            </td>
          </tr>
          <tr>
            <td>
              <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.checklist5c">
                {{$t('medium_grant.diligence__9_checklist5c')}}
              </base-checkbox>
            </td>
            <td>
              {{$t('medium_grant.diligence__9_checklist5c_label')}}
            </td>
            <td>
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionTimesheetForm" :file-data="GrantForm.files.diligence.revisionTimesheetForm" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionTimesheetForm"></upload-file>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <p class="mt-3">{{$t('medium_grant.diligence__9_iucn_may_request')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title"><strong>{{$t('medium_grant.diligence__9_certification')}}</strong></h4>
        <p class="mt-3 white-space-pre">{{$t('medium_grant.diligence__9_certification_sub')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="mt-5"></div>
        <div class="mb-2">
          <label>{{$t('medium_grant.diligence__9_signature')}}</label>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionSignature" :file-data="GrantForm.files.diligence.revisionSignature" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionSignature"></upload-file>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
          name="diligence.name"
          v-model="GrantForm.revisionModel.diligence.name"
          :error="getError('diligence.name')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.diligence__9_name')"
          :label="$t('medium_grant.diligence__9_name')"
          :placeholder="$t('medium_grant.diligence__9_name')"
        >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
          name="diligence.position"
          v-model="GrantForm.revisionModel.diligence.position"
          :error="getError('diligence.position')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.diligence__9_position')"
          :label="$t('medium_grant.diligence__9_position')"
          :placeholder="$t('medium_grant.diligence__9_position')"
        >
          </textarea>
        </div>
        <base-input
          name="diligence.date"
          v-model="GrantForm.revisionModel.diligence.date"
          :error="getError('diligence.date')"
          v-validate="'required'"
          :data-vv-as="$t('medium_grant.diligence__9_date')"
          :placeholder="$t('medium_grant.diligence__9_date')"
        >
          <label>{{$t('medium_grant.diligence__9_date')}}</label>
          <el-date-picker
            type="date"
            v-model="submitDate"
            :placeholder="$t('medium_grant.diligence__9_date')"
          >
          </el-date-picker>
        </base-input>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-3">
        <div class="mt-5"></div>
        <div>
          <label>{{$t('medium_grant.diligence__9_signature_org')}}</label>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionOrgStamp" :file-data="GrantForm.files.diligence.revisionOrgStamp" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionOrgStamp"></upload-file>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {DatePicker} from 'element-ui';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        submitDate: '',
        moment: ''
      }
    },
    beforeMount() {
      this.moment = require('moment');

      if (GrantForm.revisionModel.diligence.date !== undefined) {
        this.submitDate = GrantForm.revisionModel.diligence.date;
      }
    },
    components: {
      [DatePicker.name]: DatePicker
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    watch: {
      submitDate(newValue, oldValue) {
        GrantForm.revisionModel.diligence.date = this.moment(newValue).format('YYYY-MM-DD');
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>
